<template>
  <div>
    <el-table max-height="450px" type  border ref="table" v-loading="loading"  :data="tableData" tooltip-effect="dark" style="width: 100%" key="tablekey2">
      <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
      <el-table-column label="用户昵称" align="center" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.memberName }}</template>
      </el-table-column>

      <el-table-column label="用户头像" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-image :src="scope.row.memberLogo" style="width: 60px; height: 60px; border-radius: 50%"></el-image>
        </template>
      </el-table-column>
      <el-table-column label="用户手机号" align="center" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.phone }}</template>
      </el-table-column>
      <el-table-column label="优惠券名称" align="center" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.couponName }}</template>
      </el-table-column>
      <el-table-column label="优惠券类型" align="center" show-overflow-tooltip>
        <template slot-scope="scope">{{getTypeName( scope.row.couponType) }}</template>
      </el-table-column>

      <el-table-column label="优惠券内容" align="center" show-overflow-tooltip width="170">
      <template slot-scope="scope">
        {{ getCouponDescription(scope.row) }}
      </template>
    </el-table-column>
    <!-- <el-table-column label="发放形式" align="center" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.faceAmount }}</template>
      </el-table-column> -->
      <el-table-column label="优惠券状态" align="center" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.useStatus==2?'已使用':'未使用'}}</template>
      </el-table-column>

      <el-table-column label="领取时间" align="center" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.createTime }}</template>
      </el-table-column>
      <el-table-column label="使用时间" align="center" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.couponTime }}</template>
      </el-table-column>
      <el-table-column label="订单编号" align="center" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.orderNumber }}</template>
      </el-table-column>

      <!-- <el-table-column label="代金券面值" align="center" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.faceAmount }}</template>
      </el-table-column>
      <el-table-column label="折扣" align="center" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.discount }}</template>
      </el-table-column>
      <el-table-column label="满多少" align="center" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.fullAmount }}</template>
      </el-table-column>
      <el-table-column label="减多少" align="center" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.reduceAmount }}</template>
      </el-table-column>
      <el-table-column label="是否有门槛" align="center" show-overflow-tooltip>
        <template slot-scope="scope">{{ getIsLimit(scope.row.isLimit )}}</template>
      </el-table-column>
      <el-table-column label="满消费/元" align="center" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.customeAmount }}</template>
      </el-table-column>
      <el-table-column label="优惠券有效期类型" align="center" show-overflow-tooltip>
        <template slot-scope="scope">{{ getLimitTypeName(scope.row.limitType) }}</template>
      </el-table-column>
      <el-table-column label="有效期开始时间" align="center" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.limitStartTime }}</template>
      </el-table-column>
      <el-table-column label="有效期结束时间" align="center" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.limitEndTime }}</template>
      </el-table-column>
      <el-table-column label="适用范围" align="center" show-overflow-tooltip>
        <template slot-scope="scope">{{ getUseAreaName(scope.row.useArea) }}</template>
      </el-table-column>
      <el-table-column label="适用用户" align="center" show-overflow-tooltip>
        <template slot-scope="scope">{{ getUserType(scope.row.userType) }}</template>
      </el-table-column>
      <el-table-column label="与其他优惠劵同享" align="center" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.isShare==1?'同享':'不同享' }}</template>
      </el-table-column>
      <el-table-column label="与优惠活动同享" align="center" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.activityShare==1?'同享':'不同享' }}</template>
      </el-table-column>
      <el-table-column label="发放数量" align="center" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.num }}</template>
      </el-table-column>
      <el-table-column label="剩余数量" align="center" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.surplusNum }}</template>
      </el-table-column>
      <el-table-column label="每人限领" align="center" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.limitNum }}</template>
      </el-table-column> -->
      <!-- <el-table-column label="领取时间" align="center" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.createTime }}</template>
      </el-table-column>
      <el-table-column label="修改时间" align="center" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.updateTime }}</template>
      </el-table-column> -->

    </el-table>
    <!-- 分页 -->
    <div class="block">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page="queryInfo.currPage" :page-sizes="[100, 200, 300, 400]" :page-size="queryInfo.pageSize"
                     layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
  </div>

</template>
<script>
export default {
  data () {
    return {

    }
  },
  props: {
    tableData: {
      typeof: Array,
      default: []
    },
    loading: {
      type: Boolean,
      default: false
    },
    total: 0,
    queryInfo: {
      pageSize: 100,
      pageCount: 1,
      currPage: 1,
      condition: { createTimeArr: [], limitTimeArr: [] }
    }
  },
  methods: {

    getCouponDescription (row) {
      let description = ''
      switch (row.couponType) {
        case 1:
        // 代金券
          description = `${row.faceAmount}元`
          break
        case 2:
        // 折扣券
          if (row.isLimit === 2) {
            description = `${row.discount * 10}折，无门槛使用`
          } else {
            description = `${row.discount * 10}折，满${row.fullAmount}元使用`
          }
          break
        case 3:
        // 满减券
          description = `${row.reduceAmount}元，满${row.fullAmount}元使用`
          break
        default:
          description = '未知类型'
      }
      return description
    },
    getIsLimit (val) {
      console.log(val)
      if (val != null) {
        if (val === 1) {
          return '有'
        }
        if (val === 2) {
          return '无'
        }
      }
      return ''
    },
    getUserType (val) {
      if (val === 1) {
        return '全部用户'
      }
      if (val === 2) {
        return '指定用户'
      }
      if (val === 3) {
        return '新用户'
      }
    },
    getUseAreaName (val) {
      if (val === 1) {
        return '全场通用'
      }
      if (val === 2) {
        return '指定商品组'
      }
      if (val === 3) {
        return '指定商品'
      }
    },
    getLimitTypeName (val) {
      if (val === 1) {
        return '固定时间'
      }
      if (val === 2) {
        return '领取时间'
      }
      if (val === 3) {
        return '长期有效'
      }
    },
    getTypeName (val) {
      if (val === 1) {
        return '代金券'
      }
      if (val === 2) {
        return '折扣券'
      }
      if (val === 3) {
        return '满减券'
      }
    },
    // 修改页数大小
    handleSizeChange (val) {
      this.saveFlag = 1
      this.queryInfo.pageSize = val
      this.getList()
    },

    // 获取当前页面
    handleCurrentChange (val) {
      this.queryInfo.currPage = val
      this.getList()
    }

  }

}
</script>
